
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scuoladellinfanzia",
      function () {
        return require("private-next-pages/scuoladellinfanzia/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scuoladellinfanzia"])
      });
    }
  